import React, { useEffect, useState } from "react";
import { AiOutlineClose, AiOutlineMenu, AiOutlineTeam } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { RiTeamFill } from "react-icons/ri";
import { CiLink, CiSearch } from "react-icons/ci";
import { TfiStatsUp } from "react-icons/tfi";
import {
  ConnectButton,
  RainbowKitProvider,
  darkTheme,
} from "@rainbow-me/rainbowkit";
import { useDispatch, useSelector } from "react-redux";
import {
  setPartnersData,
  setToastPartnerError,
  setUserData,
  setUserId,
  setshowcomponents,
} from "../Store/userslice";
import axios from "axios";
import Loader from "../Loader/Loader";
import logo from "../../asstes/logo.jpg";
import { Bounce, ToastContainer, toast } from "react-toastify";

const DashBoardNavbar = () => {
  const apiUrl = process.env.REACT_APP_API;
  const dispatch = useDispatch();
  //-----------States----------
  const [nav, setNav] = useState(false);
  const [inputValue, setinputValue] = useState(1);
  const [ShowLoader, setShowLoader] = useState(true);
  //----------Get Redux Data-----------
  const UserId = useSelector((state) => state.user.UserId);
  const PartnersDetails = useSelector((state) => state.user.PartnersDetails);
  const UserState = useSelector((state) => state.user.UserState);
  const newinput = inputValue !== null ? inputValue : UserId;
  //-----------Funtions------------
  const handleGo = async (id) => {
    setShowLoader(false);
    dispatch(setUserId(id));
    dispatch(setshowcomponents(0));
    if (id) {
      try {
        const response = await axios.get(`${apiUrl}/users/user-data/${id}`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        setShowLoader(true);
        dispatch(setUserData(response.data));
        if (response) {
          partners(id);
        }
      } catch (error) {
        console.log("error", error);
        setShowLoader(true);
        toast(`${error.response.data.error}`, {
          position: "bottom-left",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    }
  };
  // --------Fetch Partners Data-------
  const partners = async (id) => {
    try {
      const response = await axios.get(`${apiUrl}/users/partners/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      dispatch(setPartnersData(response.data));
    } catch (error) {
      console.log("error", error);
      dispatch(setToastPartnerError());
    }
  };
  //---Get Input Value---------
  const handlechange = (e) => {
    setinputValue(e.target.value);
    handleupate(e.target.value);
  };
  // -----------
  useEffect(() => {
    if (UserState === true) {
      handleGo(UserId);
      handleupate(UserId);
      setinputValue(null);
    }
  }, [UserId]);
  //--------Call API----------
  useEffect(() => {
    handleGo(1);
    dispatch(setUserId(1));
    handleupate(1);
  }, []);
  //--------Call API on press Enter----------
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleGo(inputValue);
    }
  };
  //----Auto Close Loader After 2 S------
  setTimeout(() => {
    setShowLoader(true);
  }, 2000);
  //-----Make URL--------
  const searchParams = new URLSearchParams(window.location.search);
  const handleupate = (NewUserId) => {
    if (NewUserId) {
      searchParams.set("UserId", NewUserId);
    } else {
      searchParams.delete("UserId");
    }
    const newURL = window.location.pathname + "?" + searchParams.toString();
    window.history.pushState({}, "", newURL);
  };

  const navItems = [
    {
      id: " Preview ID1701890",
      input: (
        <input
          type="text"
          id="full-name"
          value={1701890}
          readOnly
          name="full-name"
          className=" mt-3 block md:hidden md:w-1/2 lg:w-2/3 w-[70%]
                bg-blue-500 rounded-lg focus:border-4 border-none
                text-base outline-none text-white py-2 px-3 leading-8 transition-colors 
                duration-200 ease-in-out"
        />
      ),
      goButton: (
        <button className="py-3 bg-blue-500 rounded-lg px-10  text-white">
          Go
        </button>
      ),
      exitButton: (
        <button className="py-3 bg-black w-full hover:bg-[#333] rounded-lg px-10  text-white">
          Exit preview mode
        </button>
      ),
    },

    { dashboardText: "Dashboard", dashboardIcon: <MdDashboard size={25} /> },
    { teamText: "Team", teamIcons: <RiTeamFill size={25} /> },
    { link: "Partners", icons: <AiOutlineTeam size={25} /> },
    { link: "Links", icons: <CiLink size={25} /> },
    { link: "Stats", icons: <TfiStatsUp size={25} /> },
  ];
  const handleNav = () => {
    setNav(!nav);
  };

  return (
    <>
      <ToastContainer />
      <div className="w-full bg-black">
        <div className="navbar-container lg:mt-4 md:mt-4 lg:ml-8  md:w-[95%] md:mx-auto md:ml-5   shadow-xl fixed  lg:w-[94%]  top-0 z-10 w-full flex justify-between items-center h-16  rounded-b-lg md:rounded-lg lg:rounded-lg  mx-auto px-4 text-white">
          {/* Desktop Navigation */}

          <div className="w-full flex md:justify-between  justify-between items-center ">
            <div className="flex w-2/2 md:w-2/3 lg:w-[45%] justify-between gap-6 items-center overflow-hidden ">
              <NavLink to="/">
                  <img src={logo} className="img-logo" />
              </NavLink>
            </div>
            <div className=" justify-around gap-8 items-center hidden md:flex  nav-input-container">
            <p className='flex font-medium  text-white Preview-ID-text'>Preview ID</p>
            <div className="hidden md:block lg:block md:w-[40%] lg:w-[40%] w-[70%] navbar-only-input-container">
              <input
                type="text"
                id="full-name"
                value={newinput}
                onChange={handlechange}
                name="full-name"
                onKeyDown={(e) => handleKeyDown(e)}
                className="navbar-button-color hidden md:block lg:block md:w-[100%] lg:w-[100%] w-[100%] rounded-lg focus:border-4 border-none text-base outline-none  py-2 px-3 leading-8 transition-colors duration-200 ease-in-out"
              />
              <CiSearch className="search-icon"/>
              </div>
              <button
                className="py-3 md:hidden hidden lg:block navbar-button-color rounded-lg px-5 "
                onClick={() => handleGo(inputValue)}
              >
                {ShowLoader ? "Go" : <Loader />}
              </button>

              <div className="font-bold  rounded-lg py-3 px-4 connectbutton-div">
                <RainbowKitProvider
                  theme={darkTheme({
                    accentColor: "#E43B4D",
                    accentColorForeground: "white",
                    borderRadius: "large",
                    fontStack: "system",
                    overlayBlur: "small",
                  })}
                >
                  <ConnectButton className="ConnectButton-color" />
                </RainbowKitProvider>
              </div>
            </div>
          </div>
          {/* Mobile Navigation Icon */}
          <div
            onClick={handleNav}
            className="block md:hidden p-2 cursor-pointer hover:bg-blue-400 rounded-full  bg-blue-500"
          >
            {nav ? "" : <AiOutlineMenu size={25} />}
          </div>

          {/* Mobile Navigation Menu */}
          <ul
            className={
              nav
                ? "fixed md:hidden left-0 top-0 w-[100%] h-full  bg-blue-600 ease-in-out duration-300"
                : "ease-in-out w-[100%] duration-300 fixed top-0 bottom-0 left-[-100%]"
            }
          >
            {/* Mobile Logo */}
            <div className="flex justify-between">
              <h1 className="w-full text-xl font-bold text-[#fff] m-4">
                FORSAGE
              </h1>
              <div
                onClick={handleNav}
                className="block md:hidden my-4 mr-4 rounded-full p-2 bg-blue-500 hover:bg-blue-400 cursor-default"
              >
                {nav ? <AiOutlineClose size={25} /> : ""}
              </div>
            </div>

            {/* Mobile Navigation Items */}
            {navItems.map((item, index) => (
              <div key={index}>
                <li className="px-5 text-2xl font-medium">{item.id}</li>
                <li className="px-5 py-6 flex items-center gap-8">
                  {item.input} <p className="mt-3">{item.goButton}</p>
                </li>
                <li className="px-5">{item.exitButton}</li>
                <li className=" flex items-center gap-3  px-5 text-white ">
                  {item.dashboardIcon}
                  <span className=" font-medium border-b  border-b-white  ">
                    {item.dashboardText}
                  </span>
                </li>
                <li className=" flex items-center gap-3  px-5 text-gray-400 ">
                  {item.teamIcons}
                  <span>{item.teamText}</span>
                </li>
                <li className="flex items-center gap-3 px-14 text-gray-400 ">
                  <p>{item.icons}</p>
                  <p>{item.link}</p>
                </li>
              </div>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default DashBoardNavbar;
